export default __webpack_public_path__ + "static/media/A5_13.ff290570.mp3";